import { IMapService } from "../types/mapService";
import {
  isReadyMessage,
  isSaveAndExitResponse,
  isEditingStartedMessage,
  isSetBaseLineResponse,
} from "../bintactMapMessages";

const getDefaultMapUrl = (): string => {
  const isProd = process.env.REACT_APP_ENVIRONMENT === "PROD";
  return isProd
    ? "https://data.apps.fao.org/?noBanner=1"
    : "https://dev-raster-painting-1036455980974.europe-west1.run.app/?lang=en&noBanner=1";
};

/**
 * Default map service implementation for Agro-Informatics map
 */
export class AgroInformaticsMapService implements IMapService {
  private readonly mapUrl: string;
  private readonly targetOrigin: string;

  constructor(mapUrl: string = getDefaultMapUrl()) {
    this.mapUrl = mapUrl;
    this.targetOrigin = new URL(mapUrl).origin;
  }

  getMapUrl(): string {
    return this.mapUrl;
  }

  getTargetOrigin(): string {
    return this.targetOrigin;
  }

  sendMessage(iframe: HTMLIFrameElement, message: unknown): void {
    if (!iframe.contentWindow) {
      console.error("Cannot send message: iframe contentWindow is not available");
      return;
    }

    try {
      iframe.contentWindow.postMessage(message, this.targetOrigin);
    } catch (error) {
      console.error("Failed to send message to map service:", error);
      throw error;
    }
  }

  validateMessageOrigin(origin: string): boolean {
    return origin === this.targetOrigin;
  }

  isMessageFromService(data: unknown): boolean {
    // Use type guard functions to validate incoming messages from the service
    // These functions already validate the message structure and source
    
    // 1. Check for BINTACT_AGRO_INFORMATICS_SOURCE string messages
    if (isReadyMessage(data) || isSaveAndExitResponse(data) || isEditingStartedMessage(data) || isSetBaseLineResponse(data)) {
      return true;
    }
        
    // Also handle nested message structures (some messages come wrapped)
    if (typeof data === "object" && data !== null) {
      const obj = data as Record<string, unknown>;
      const messageValue = obj.message;
      
      if (messageValue && typeof messageValue === "object") {
        if (isSaveAndExitResponse(messageValue) || isEditingStartedMessage(messageValue) || isSetBaseLineResponse(messageValue)) {
          return true;
        }
      }
    }
    
    return false;
  }
}

// Export a default instance
export const agroInformaticsMapService = new AgroInformaticsMapService(getDefaultMapUrl());

